import { render, staticRenderFns } from "./UnauthorizedModal.vue?vue&type=template&id=390d35ce&scoped=true&"
import script from "./UnauthorizedModal.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d35ce",
  null
  
)

export default component.exports